/*Global Dependencies*/
import React, { useState} from "react";
import { Tooltip,Spin, Modal} from "antd";
import Highlighter from "react-highlight-words";
/*Local Dependencies*/
import "./genExpense.scss";
import GenericTable from "../../../genericTable/genericTable";
import NotesModal from "../../notesModal/notesModal";
import {useNavigate} from "react-router-dom";
import memberService from "@services/members.service";
import { routeMap } from "@utils/constants";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import { useGlobalInformationStore } from "@stores/global_informationStore";
import { useHighCostPatientStore } from "@stores/highCostPatientStore";
import { isEmpty } from "lodash";

const GenericExpense = ({activeTab , showModel , setShowModel , top10 ,rowsPerPage, 
  setRowsPerPage ,searchData , setSearchData ,  currentPage, setCurrentPage, sortData , setSortData , tableLoader , setTableLoader,
  searchKeywordNew , setSearchKeywordNew , refreshDate ,  selectedRecord , columnData , tableData , setTableData , buildDone , defaultDisplay , totalCount , setTotalCount , getTableData} : any) => {

  const {expenseType} = activeTab;
  const navigate = useNavigate();
  const [navigationLoader , setNavigationLoader] = useState<{loading : boolean , patientName : string}>({loading : false , patientName : ""});

  const _setisNextScrollNeeded = useGlobalInformationStore((state) => state._setisNextScrollNeeded);
  const setColumnData = useHighCostPatientStore((state) => state.setColumnData);
  const encountersDataNavigation = (text : string ,record: any) => { 
    //to fetch the patient data for whose member details encounters data we navigate to  
    console.log("genExpense.encountersDataNavigation");
    setNavigationLoader({loading : true , patientName : text});
    memberService.membersByIds([record.patient_id]).subscribe({
      next: (v) => {
        setNavigationLoader({loading : false , patientName : ""});
        let member = v?.data?.data?.patientList.pop();
        if (member) {
          memberService.setCurrentMember = member;
          memberService.setsingleMember = false;
          
          _setisNextScrollNeeded(true)
          navigate(routeMap.memberProfile ,  { state: { from: routeMap.dashboard , fromLabel : "Reports / High Cost Patient Report" ,tabKeyToFocus : "10"}});
        }
      },
      error: (e) => {
        setNavigationLoader({loading : false , patientName : ""});
      },
    })
  };

  const highlighterDiv = (text: any, searchWord: any, dataIndex: any, record: any) => {
    //to render the cells of the table
    console.log("genExpense.highlighterDiv");
    switch (dataIndex) {
      case "patient_name":
        return (
          <Spin spinning={navigationLoader.loading && navigationLoader.patientName === text} indicator={<HealthemSpinner />}>
            <span className="f16 fw500 blue-color cursor-type--pointer" onClick={() => encountersDataNavigation(text, record)}>
              <Tooltip placement="topLeft" title={text ? text.toString() : ""}>
                <Highlighter highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }} searchWords={[searchWord]} autoEscape textToHighlight={text ? text.toString() : ""} />
              </Tooltip>
            </span>
          </Spin>
        );
      default:
        return (
          <Tooltip placement="topLeft" title={text ? text.toString() : ""}>
            <Highlighter highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }} searchWords={[searchWord]} autoEscape textToHighlight={text ? text.toString() : ""} />
          </Tooltip>
        );
    }
  };

  const onModalCancel = () => {
    //to execute action on cancel in modal 
    console.log("genExpense.onModalCancel");
    setShowModel(false);
  };

  const removeSortOrderFromResponse = (response: any , sortType : string) => {
    //to remove sort order from the table so normal sort can be performed on the columns 
    return response.map((column: any) => {
      const { sortOrder, ...columnWithoutSortOrder } = column;
      if(column.dataIndex === 'current_rank' && !sortType){
        return {sortOrder : 'ascend' , ...columnWithoutSortOrder};
      } else {
        return columnWithoutSortOrder;
      }
    });
  };

  const handleSortChange = (sortBy : string , sortType : string) => {
    //to handle the sort change and remove sort order to perform normal sort in the table
    console.log("genExpense.handleSortChange");
    const columnDataObj = Object.fromEntries(Object.keys(columnData).map(key => [key, removeSortOrderFromResponse(columnData[key] , sortType)]));
    const sortObj = Object.fromEntries(Object.keys(sortData).map(key => [key, sortType ? {sortBy : sortBy , sortType : sortType} : {}]));
    setColumnData({...columnData , ...columnDataObj});
    setSortData({...sortData , ...sortObj});
    getTableData({sortBy : sortBy , sortType : sortType || 'none'});
  }

  const handleCurrentPage = (e : number) => {
    console.log("genExpense.handleCurrentPage");
    // to handle pagination change
    setCurrentPage({...currentPage , [expenseType] : e});
  }

  const handleSearchData = (data : any) => {
    // to handle search data
    console.log("genExpense.handleSearchData");
    const obj = Object.fromEntries(Object.keys(searchData).map(key => [key, data]));
    setSearchData({...searchData , ...obj});
  }

  const handleSearchKeywordNew = (data : any) => {
    //to handle search data
    console.log("genExpense.handleSearchKeywordNew");
    const obj = Object.fromEntries(Object.keys(searchKeywordNew).map(key => [key, data]));
    setSearchKeywordNew({...searchKeywordNew , ...obj})
  }

  const handleRowsPerPage = (e : number) => {
    // to handle rows per page and will reset all tabs to first page on change
    setCurrentPage({"Part A" : 1 , "Part B" : 1 , "Part D" : 1 , "Total" : 1});
    setRowsPerPage(e);
  }

  return (
    <div className={`expense__table ${!buildDone ? 'dnone' : ''}`}>
      <GenericTable
        columns={columnData[expenseType]}
        tableData={tableData[expenseType]}
        setTableData={setTableData}
        highlighterDiv={highlighterDiv}
        columnSearchInfo={searchData[expenseType]}
        setColumnSearchInfo={handleSearchData}
        searchRequired={true}
        paginationRequired={true}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={handleRowsPerPage}
        currentPage={currentPage[expenseType]}
        setCurrentPage={handleCurrentPage}
        totalCount={totalCount}
        tableLoader={tableLoader || columnData?.length <= 0}
        getTableData={getTableData}
        handleSortChange={handleSortChange}
        searchKeywordNew={searchKeywordNew[expenseType]}
        setSearchKeywordNew={handleSearchKeywordNew}
        noColSearchSort = {["notes"]}
        renderCols = {['notes']}
        noDataText={(!isEmpty(searchData[expenseType]) && top10 && tableData[expenseType].length <= 0) ? 'The searched member is not available in the top 10 search results, please switch to the "All" tab to expand and view all available results' : undefined}
      />
      <Modal className="highCostPatient__modal_container" title={selectedRecord.patient_name} visible={showModel} footer={null} onCancel={onModalCancel} wrapClassName={"highCostPatient__Modal"} maskClosable={false} zIndex={30}
      maskStyle={{ position: "fixed",top: '0',width: '100vw',height: '100vh',zIndex: '25',left: '96.4px'}}>
        <NotesModal currrentTab={expenseType} refreshDate={refreshDate} patient_id={selectedRecord.patient_id} tableData={tableData} setTableData={setTableData}/>
      </Modal>
    </div>
  )
};

export default GenericExpense;